<template>
    <div id="app" class="has-top-banner" :style="{ '--top-banner-height': topBannerHeight + 'px' }">
        <top-banner
            :text="topBannerText"
            :link-url="topBannerLinkUrl"
            :link-label="topBannerLinkLabel"
        />
        <router-view name="header"/>
        <main :class="{'main':$route.name !== 'Register' && $route.name !== 'Login' && $route.name !== 'Reset Password' && $route.name !== 'New Password'}">
            <router-view name="navigation"/>
            <router-view />
        </main>
    </div>
</template>

<style lang="scss">
    @import '_assets/_scss/main';
</style>

<script>
    import { mapGetters } from "vuex";
    import {setBaseUrl} from "@/services/axios.service";
    import TopBanner from "@/components/_globals/TopBanner";

    export default {
        name: 'app',
        components: {
            TopBanner
        },
        data() {
            return {
                topBannerHeight: 36,
                topBannerText: 'Das digitale Projekthandbuch wird in Form dieser Website ab 01.04.26 nicht mehr aktualisiert. Alle Inhalte sind zukünftig im Stammwissen unter folgendem Link zu finden:',
                topBannerLinkUrl: 'https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.2.stammstrecke-muenchen.de%2fprojekthandbuch.html&c=E,1,oYD1CGtSE6v5KaC-E6MNqjNCrYHp5mrshi81dr-bwBAwZXoaGNhReLnsbcNrFNFl_Jdz6ottiVFM-K6Ud8nEBC699LFEsZhHD3szZJKS&typo=1',
                topBannerLinkLabel: 'Zum Stammwissen'
            }
        },
        computed:{
            ...mapGetters({
                navigation: 'content/getNav'
            }),
        },
        mounted(){
            // if(!this.navigation.length)
            //     this.$store.dispatch('content/initData');
            setBaseUrl();
        }
    }
</script>
